import { Controller } from "@hotwired/stimulus"
import { showConfirmModal } from "../lib/custom_confirm"

// Mounted on the "Create #channel & save" button shown in the app-setting edit
// form when a Slack channel was not found. Confirms channel creation with the
// admin, flips the form's hidden create_channel field to "1", then submits the
// form. The app-setting-confirm controller on the same form detects the flag
// and skips its generic save confirmation, so the admin sees a single dialog.
export default class extends Controller {
  static values = { channel: String }

  async create () {
    const confirmed = await showConfirmModal(
      `This will create a new public Slack channel #${this.channelValue} and then save the setting. Continue?`,
      { variant: "warning", title: "Create Slack Channel", confirmText: "Create & Save" }
    )
    if (!confirmed) return

    const form = this.element.closest("form")
    if (!form) return

    const field = form.querySelector('input[name="create_channel"]')
    if (field) field.value = "1"
    form.requestSubmit()
  }
}
